var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccAdd28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/add-28"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 205",
    cx: 14,
    cy: 14.0001,
    r: 13.5,
    stroke: "#191E23"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 427320629"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 15",
    x1: 7,
    y1: 13.8668,
    x2: 21,
    y2: 13.8668,
    stroke: "#191E23",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 16",
    x1: 14.1332,
    y1: 7.00012,
    x2: 14.1332,
    y2: 21.0001,
    stroke: "#191E23",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccAdd28);
export default __webpack_public_path__ + "static/media/acc-add-28.ca13e9c99b44d94628b930cf1b997d8f.svg";
export { ForwardRef as ReactComponent };